import { REQUEST_METHOD_GET, REQUEST_METHOD_POST, allRequest, postRequest } from "../../../../../middlewares/api/actions";
import { getCreateCalcFieldUrl, getCalcFieldUrl, getDistinctTempTableFieldURL, getImportCaseFunctionURL, getUploadFileOnServerUrl, getCsvTablePreviewUrl, getEditCalcFieldUrl } from "../../../../../constants/urls";

export const FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_SHOW = 'FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_SHOW';
export const FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_HIDE = 'FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_HIDE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_VALUE_TYPE = 'FILE_MAPPING_WIZARD_ADD_FIELD_VALUE_TYPE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_TYPE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_TYPE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_HIDE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_HIDE';

export const FILE_MAPPING_WIZARD_ADD_FIELD_COLUMN_SELECT = 'FILE_MAPPING_WIZARD_ADD_FIELD_COLUMN_SELECT';

export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FORM_CHANGE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_RESET = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_RESET';

export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_FORM_CHANGE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_FORM_CHANGE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_FORM_CHANGE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_FORM_CHANGE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CONCAT_FORM_CHANGE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CONCAT_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IIF_FORM_CHANGE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IIF_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CASE_FORM_CHANGE = ' FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CASE_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_FORM_CHANGE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_HIDE_MODAL = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_HIDE_MODAL';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_SHOW = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_SHOW';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_HIDE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_HIDE';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_CSV_ROWS = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_CSV_ROWS';

export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IMPORT_FILEPATH = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IMPORT_FILEPATH';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_UPLOAP_PREVIEW = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_UPLOAP_PREVIEW'
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_CLEAR = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_CLEAR';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_CLEAR = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_CLEAR';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_CLEAR = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_CLEAR';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_CLEAR = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_CLEAR';

export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBMIT = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBMIT';

export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_CURSOR_SET = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_CURSOR_SET';
export const FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_FIELD_PASTE = 'FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_FIELD_PASTE';

export const FILE_MAPPING_WIZARD_ADD_FIELD = 'FILE_MAPPING_WIZARD_ADD_FIELD';
export const FILE_MAPPING_WIZARD_SELECT_DISTINCT = 'FILE_MAPPING_WIZARD_SELECT_DISTINCT'


export const showFileMappingWizardAddFieldModal = () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_SHOW
});

export const hideFileMappingWizardAddFieldModal = () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_MODAL_HIDE
});

export const fileMappingWizardAddFieldValueType = type => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_VALUE_TYPE,
  valueType: type
});

export const fileMappingWizardAddFieldFunctionWizardType = type => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_TYPE,
  functionType: type
});

export const fileMappingWizardAddFieldFunctionWizardRightClick = type => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_FIELD_PASTE,
  field: type.Function,
  isRightClick: true
});

export const hideFileMappingWizardAddFieldFunctionWizard = () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_WIZARD_HIDE
});

export const showFileMappingWizardAddFieldFunctionSubstrFormChange = fields => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_FORM_CHANGE,
  fields: fields
})

export const showFileMappingWizardAddFieldFunctionReplaceFormChange = fields => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_FORM_CHANGE,
  fields: fields
})

export const showFileMappingWizardAddFieldFunctionTrimFormChange = fields => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_FORM_CHANGE,
  fields: fields
})

export const showFileMappingWizardAddFieldFunctionPadFormChange = fields => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_FORM_CHANGE,
  fields: fields
})

export const onFormulaReset = () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_RESET
})

export const onClearSubsrt = () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBSTR_CLEAR,
})

export const onClearReplace = () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_REPLACE_CLEAR,
})

export const onClearTrim = () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_TRIM_CLEAR,
})

export const onClearPad = () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_PAD_CLEAR,
})

export const onOperatorCopy = operatorLabel => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_FIELD_PASTE,
  field: operatorLabel
})

export const onSubmitFunction = (functionTypeName, functionTypeBase) => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_SUBMIT,
  functionTypeName: functionTypeName,
  functionTypeBase: functionTypeBase
})

export const selectFileMappingWizardColumn = columnName => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_COLUMN_SELECT,
  columnName
});

export const onFunctionFormDataChange = fields => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FORM_CHANGE,
  fields: fields
})

export const setFunctionEditorCursor = inputTarget => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_CURSOR_SET,
  cursorStart: inputTarget.selectionStart,
  cursorEnd: inputTarget.selectionEnd
})

export const onCopyFieldName = field => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_EDITOR_FIELD_PASTE,
  field: `[${field}]`
})

export const saveField = (tableName, functionData) => ({
  ...allRequest(
    FILE_MAPPING_WIZARD_ADD_FIELD,
    [REQUEST_METHOD_POST, REQUEST_METHOD_GET],
    [getCreateCalcFieldUrl(tableName), getCalcFieldUrl(tableName)],
    [{
      PageNum: 0,
      PageSize: 0,
      FilterTable: [],
      SortCols: [],
      SortByDesc: false,
      SelCols: null,
      HasCalculatedField: true,
      CalculatedFieldName: functionData.nameValue,
      CalculatedFieldExpression: functionData.functionValue
    }]
  ),
})

export const saveFixedField = (tableName, functionData) => ({
  ...allRequest(
    FILE_MAPPING_WIZARD_ADD_FIELD,
    [REQUEST_METHOD_POST, REQUEST_METHOD_GET],
    [getCreateCalcFieldUrl(tableName), getCalcFieldUrl(tableName)],
    [{
      PageNum: 0,
      PageSize: 0,
      FilterTable: [],
      SortCols: [],
      SortByDesc: false,
      SelCols: null,
      HasCalculatedField: true,
      CalculatedFieldName: functionData.nameValue,
      CalculatedFieldExpression: `'${functionData.functionValue.replace(/'/g, "''")}'`
    }]
  ),
})

export const editField = (tableName, functionData) => ({
  ...allRequest(
    FILE_MAPPING_WIZARD_ADD_FIELD,
    [REQUEST_METHOD_POST, REQUEST_METHOD_GET],
    [getEditCalcFieldUrl(tableName, functionData.originalName), getCalcFieldUrl(tableName)],
    [{
      PageNum: 0,
      PageSize: 0,
      FilterTable: [],
      SortCols: [],
      SortByDesc: false,
      SelCols: null,
      HasCalculatedField: true,
      CalculatedFieldName: functionData.nameValue,
      CalculatedFieldExpression: functionData.functionValue
    }]
  ),
})

export const editFixedField = (tableName, functionData) => ({
  ...allRequest(
    FILE_MAPPING_WIZARD_ADD_FIELD,
    [REQUEST_METHOD_POST, REQUEST_METHOD_GET],
    [getEditCalcFieldUrl(tableName, functionData.originalName), getCalcFieldUrl(tableName)],
    [{
      PageNum: 0,
      PageSize: 0,
      FilterTable: [],
      SortCols: [],
      SortByDesc: false,
      SelCols: null,
      HasCalculatedField: true,
      CalculatedFieldName: functionData.nameValue,
      CalculatedFieldExpression: `'${functionData.functionValue.replace(/'/g, "''")}'`
    }]
  ),
})

export const onChangeConcat = fields => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CONCAT_FORM_CHANGE,
  fields: fields
})

export const onChangeIfFunction = value => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IIF_FORM_CHANGE, 
  value
})

export const onChangeCaseFunction = value => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_CASE_FORM_CHANGE,
  value
})

export const onChangeFileFunction = fields => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_FORM_CHANGE,
  fields:fields
})

export const  hideFileComponentFunctionWizard = () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_HIDE_MODAL
})

export const getImportCaseFunction = (separator,delimiter,hasHeader,filePath,fieldName) => postRequest(
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_IMPORT_FILEPATH,
  getImportCaseFunctionURL(separator,delimiter,hasHeader,filePath,fieldName)
)

export const submitFileMappingWizardFileComponent = (file) => {
  let fileFormData = new FormData();
  fileFormData.append('file', file);

  return postRequest(
    FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_UPLOAP_PREVIEW,
    getUploadFileOnServerUrl(),
    fileFormData,
    t => ({
      start: t('scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.start'),
      success: t("scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.success")
    })
  );
};

export const showfileServerPreview =  () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_SHOW 
})

export const hidefileServerPreview =  () => ({
  type: FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_MODAL_HIDE 
})



export const getFileMappingWizardFileComponentPreview = (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, filePath) => postRequest(
  FILE_MAPPING_WIZARD_ADD_FIELD_FUNCTION_FILE_PREVIEW_CSV_ROWS,
  getCsvTablePreviewUrl(separator, delimiter, hasHeader, filePath, null, null),
  {
    PageNum: pageNum,
    PageSize: pageSize,
    FilterTable: filterTable,
    SortCols: sortCols,
    SortByDesc: sortByDesc
  }
);


export const getDistinctTempTable = (tableName, query, filters, pageNum,pageSize,sortByDesc, sortCol) => postRequest(
  FILE_MAPPING_WIZARD_SELECT_DISTINCT,
  getDistinctTempTableFieldURL(tableName),
  {
    PageNum:pageNum,
    PageSize:pageSize,
    FilterTable: filters,
    SortCols: [sortCol],
    SortByDesc: sortByDesc,
    SelCols: null,
    HasCalculatedField: true,
    CalculatedFieldName: query,
    CalculatedFieldExpression: `SELECT DISTINCT ${query} as VALUE FROM ${tableName}`
  }
)